import { DiaUtil } from "core/features/ingresso/typings";
import { api } from "infra/axios";
import { useQuery } from "react-query";

function useGetDiasUteis() {
  const endpoint = `/v2/ingressos/calendario`;

  return useQuery([endpoint], async () => {
    const { data } = await api.get(endpoint);

    return data as DiaUtil[];
  });
}

export default useGetDiasUteis;
